export const ASCII_CODES = {
    ENTER: 13,
};

export const ACCESSIBILITY_TEXT = {
    AMOUNT_ENTERED: "{0} rupees entered in textbox, tap to edit amount",
    ENTER_AMOUNT: "Enter the amount to be added to swiggy money wallet",
};
